export const SIDEBAR_NAMES = {
  NEW_CHAT: "sideMenu.newChat",
  CHAT_HISTORY: "sideMenu.chatHistory",
  FAQ: "sideMenu.faq",
  CONTACT: "sideMenu.contact",
  TERMS_CONDITION: "sideMenu.terms",
  PRIVACY_POLICY: "sideMenu.privacy",
  SETTINGS: "sideMenu.setting",
};

export enum SIDEBAR_ICON_NAMES {
  NEW_CHAT = "NewChat",
  CHAT_HISTORY = "ChatHistory",
  FAQ = "FAQ",
  CONTACT = "Contact",
  TERMS_CONDITION = "TermsCondition",
  PRIVACY_POLICY = "PrivacyPolicy",
  SETTINGS = "Settings",
}

export enum ROUTE_NAMES {
  HOME = "/",
  LOGIN = "/login",
  SINGUP = "/signup",
  FORGET_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  RESET_SUCCESS = "/reset-success",
  CHECK_YOUR_EMAIL = "/check-your-email",
  EMAIL_VERIFICATION = "/email-verification",
  DASHBOARD = "/dashboard",
  LEGAL_CHATBOT = "/legal-chatbot",
  DOCUMENT_INTEGRATION_CHATBOT = "/project-document-chatbot",
  CHAT_HISTORY = "/chatHistory",
  PRIVACY_POLICY = "/privacyPolicy",
  TERMS_CONDITION = "/termsconditions",
  USER_PROFILE = "/userProfile",
  FAQ = "/faqs",
  CONTACT = "/contactUs",
  CHAT_BY_ID = "/chat/:id",
  ASK_AI_CHATBOT_CHAT = "/askAiFlow/Chat",
  ASK_AI_CHATBOT_CHAT_BY_ID = "/askAiFlow/Chat/:id",
  ADMIN_USER_MANAGEMENT = "/admin/user-management",
  SETTINGS = "/settings",
  API_DASHBOARD = "/api-dashboard",
  SHARED_CHAT = "/shared/chat/:uid",
  SHARED_THREAD = "/thread/:thraedUID",
  USER_SUBSCRIPTION = "/usersubscription",
  SUBSCRIPTION_SUCCESS = "/subscription-success",
  MY_DOCUMENT = "/my-document",
  ADMIN_USERS_MANAGMENT = "/admin/users/manage",
  CONGPT_CHAT_SCREEN = "/c/congpt",
  KSCE_CHAT_SCREEN = "/chat",
  ALL_SET = "/all-set",
  LETS_START = "/lets-start",
  ADMIN_ANALYTICS = "/admin/analytics",
  ADMIN_LOGIN = "/admin/login",
  RISKCHECKER_CHAT_SCREEN = "/c/risk-checker",
  CHECKLIST = "/checklist",
  DOCUMENT = "document",
  DOCUMENT_CHAT = "/document-chat",
  CHECKLIST_CHAT = "/checklist-chat",
  DOCUMENT_CHAT_BY_ID = "/document-chat/:id",
  CHECKLIST_CHAT_BY_ID = "/checklist-chat/:id",
  PERMIT_REVIEW = "/permitreview",
  SINGLE_PERMIT_REVIEW = "/permitreview/:id",
  DRAWING_ANALYSIS = "/drawing-analysis",
  DRAWING_ANALYSIS_CHAT = "/drawing-analysis-chat",
  DRAWING_ANALYSIS_CHAT_BY_ID = "/drawing-analysis-chat/:id",
  LOADING = "/loading",
  LEGAL_REVIEW = "/legal-review",
  SINGLE_LEGAL_REVIEW = "/legal-review/:id",
  DRAWING_PREVIEW = "/drawingpreview",
  UPLOAD_DOCUMENT = "/uploaddocument",
  MATERIAL_CAMPARISON = "/materialcamparison",
  DOC_VIEWER = "/doc-viewer",
  KCS = "/kcs",
  KCS_CHAT = "/kcs-chat",
  KCS_CHAT_BY_ID = "/kcs-chat/:id",
  CHAT_HISTORY_DASHBOARD = "/chat-history",
  RISK_ASSESSMENT = "/risk-assessment",
  RISK_ASSESSMENT_DETAIL = "/risk-assessment-detail/:id",
  ASK_AI_CHATBOT = "/ask-ai-chatbot",
  MULTI_AI_CHATBOT = "/multi-ai-chatbot",
  LEGAL_COMPLIANCE = "/legal-compliance",
}
